import { Link, usePage } from "@inertiajs/react"
import { CarouselItem } from "./CarouselItem"
import Carousel from "../Common/Carousel"

export const RecentlySold = () => {
    const { sold: items } = usePage().props
    return (
        <div className="flex flex-col items-center w-full gap-8 pt-8 pb-8 lg:pt-8">
            <div className="flex flex-col items-center -mb-8">
                <h2 className="text-2xl font-bold text-black lg:text-3xl">
                    Recently Sold Firearms
                </h2>
                <p className="mt-4 text-sm font-normal text-black lg:text-xl">
                    See what's been moving in the market
                </p>
            </div>

            <div className="w-full lg:w-[1228px] h-full rounded-b-[16px]">
                <Carousel items={items} itemTemplate={CarouselItem} />
            </div>

            <Link href={"/auctions/?auction_status=sold"}>
                <div className="lg:mt-4 sm:ms-5 lg:ms-0 flex h-[48px] w-[225px] text-neutral-50 rounded-md transition-colors bg-[#800020] hover:bg-maroon-light items-center justify-center">
                    View All
                </div>
            </Link>
        </div>
    )
}
